
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Lauge_Hansen",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Lauge_Hansen.vue